import config from 'config';

const colors = {
  ...config.colors
};

export default colors;
